import { IOrganizationSettingsInitialValues } from '../../../types';

export const INITIAL_VALUES: IOrganizationSettingsInitialValues = {
  id: undefined,
  name: '',
  title: '',
  is_active: true,
  tax_number: '',
  tax_office: '',
  address: '',
};
